import siteConfig from "../config/siteConfig";

export const formatPrice = (amount) =>
  new Intl.NumberFormat(siteConfig.locale, {
    style: "currency",
    currency: siteConfig.currency,
    minimumFractionDigits: 2,
  }).format(Number(amount) || 0);

export const itemKey = (item) => `${item.id}:${item.size}:${item.color}`;
export const clampQuantity = (value) =>
  Math.min(10, Math.max(1, Math.floor(Number(value) || 1)));
export const getShipping = () => siteConfig.shipping.flatRate;

export function readStorage(key, fallback, session = false) {
  try {
    return (
      JSON.parse((session ? sessionStorage : localStorage).getItem(key)) ??
      fallback
    );
  } catch {
    return fallback;
  }
}
export function writeStorage(key, value, session = false) {
  try {
    (session ? sessionStorage : localStorage).setItem(
      key,
      JSON.stringify(value),
    );
    return true;
  } catch {
    return false;
  }
}
export function imageFallback(event) {
  const img = event.currentTarget;
  img.onerror = null;
  img.src = "/img/image-unavailable.svg";
}
